/* global debounce, onKeyUpEscape */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super()
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)

    initEventListeners()
    FacetFiltersForm.setSortByChangeHandler()

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event)
    }, 500)

    const facetForm = this.querySelector('form')
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this))

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop')
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape)
  }

  static setSortByChangeHandler() {
    document
      .querySelectorAll('#CollectionSortSelect [data-select=item]')
      .forEach(($item) => {
        $item.addEventListener('select:change', (event) => {
          const value = event.detail.value
          const $sortBy = document.querySelector('input#sort_by')
          $sortBy.value = value
          document
            .querySelector('#FacetFiltersForm')
            .dispatchEvent(new InputEvent('input'))
        })
      })
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial
      if (searchParams === FacetFiltersForm.searchParamsPrev) return
      FacetFiltersForm.renderPage(searchParams, null, false)
    }
    window.addEventListener('popstate', onHistoryChange)
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable)
    })
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams
    const sections = FacetFiltersForm.getSections()

    document.getElementById('ProductGridContainer').classList.add('loading')
    document
      .querySelectorAll('[data-product-count]')
      .forEach(($elm) => $elm.classList.add('loading'))

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
      const filterDataUrl = (element) => element.url === url

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event)
    })

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams)
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ]
        FacetFiltersForm.renderFilters(html, event)
        FacetFiltersForm.renderProductGrid(html)
        FacetFiltersForm.renderProductCount(html)
        window.dispatchEvent(new Event('filter:dom:updated'))
        initEventListeners()
      })
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html
    FacetFiltersForm.renderFilters(html, event)
    FacetFiltersForm.renderProductGrid(html)
    FacetFiltersForm.renderProductCount(html)
    window.dispatchEvent(new Event('filter:dom:updated'))
    initEventListeners()
  }

  static renderProductGrid(html) {
    document.getElementById('product-grid').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('product-grid').innerHTML
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('[data-product-count]').innerHTML
    document.querySelectorAll('[data-product-count]').forEach(($elm) => {
      $elm.innerHTML = count
      $elm.classList.remove('loading')
    })
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
    const $facetFilterForm = parsedHTML.getElementById('FacetFiltersForm')
    document.getElementById('FacetFiltersForm').innerHTML =
      $facetFilterForm.innerHTML
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.active-facets-mobile',
      '.active-facets-desktop',
    ]

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector)
      if (!activeFacetsElement) return
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML
    })

    FacetFiltersForm.toggleActiveFacets(false)
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sorting',
    ]

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML
    })
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected')
    const sourceElement = source.querySelector('.facets__selected')

    const targetElementAccessibility = target.querySelector('.facets__summary')
    const sourceElementAccessibility = source.querySelector('.facets__summary')

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML =
        source.querySelector('.facets__selected').outerHTML
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML =
        source.querySelector('.facets__summary').outerHTML
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
    )
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form)
    return new URLSearchParams(formData).toString()
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event)
  }

  /**
   * @param {Event} event
   */
  onSubmitHandler(event) {
    event.preventDefault()
    const sortFilterForms = document.querySelectorAll(
      'facet-filters-form form, form[data-form=sort]',
    )
    const forms = []

    sortFilterForms.forEach((form) => {
      forms.push(this.createSearchParams(form))
    })
    this.onSubmitForm(forms.join('&'), event)
  }

  onActiveFilterClick(event) {
    event.preventDefault()
    FacetFiltersForm.toggleActiveFacets()
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf('?') + 1,
          )
    FacetFiltersForm.renderPage(url)
  }
}

FacetFiltersForm.filterData = []
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)
customElements.define('facet-filters-form', FacetFiltersForm)
FacetFiltersForm.setListeners()

class PriceRange extends HTMLElement {
  constructor() {
    super()
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this)),
    )
    this.setMinAndMaxValues()
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget)
    this.setMinAndMaxValues()
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input')
    const minInput = inputs[0]
    const maxInput = inputs[1]
    if (maxInput.value) minInput.setAttribute('max', maxInput.value)
    if (minInput.value) maxInput.setAttribute('min', minInput.value)
    if (minInput.value === '') maxInput.setAttribute('min', 0)
    if (maxInput.value === '')
      minInput.setAttribute('max', maxInput.getAttribute('max'))
  }

  adjustToValidValues(input) {
    const value = Number(input.value)
    const min = Number(input.getAttribute('min'))
    const max = Number(input.getAttribute('max'))

    if (value < min) input.value = min
    if (value > max) input.value = max
  }
}

customElements.define('price-range', PriceRange)

class FacetRemove extends HTMLElement {
  constructor() {
    super()
    const facetLink = this.querySelector('a')
    facetLink.setAttribute('role', 'button')
    facetLink.addEventListener('click', this.closeFilter.bind(this))
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault()
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event)
    })
  }

  closeFilter(event) {
    event.preventDefault()
    const form =
      this.closest('facet-filters-form') ||
      document.querySelector('facet-filters-form')
    form.onActiveFilterClick(event)
  }
}

customElements.define('facet-remove', FacetRemove)

/* global FloatingUIDOM */
function initEventListeners() {
  const filterContainer = document.getElementById('filter-container')
  const openFilterButton = document.querySelectorAll('[data-filter-open]')
  const closeFilterButton = document.querySelectorAll('[data-filter-close]')

  /**
   * @param {HTMLButtonElement} $button
   */
  function initPopover($button) {
    const popoverId = $button.getAttribute('data-popover-button')
    const $popover = document.getElementById(popoverId)

    $button.addEventListener('click', (event) => {
      event.stopPropagation()

      if (isPopoverOpen($popover)) {
        $popover.style.display = 'none'
      } else {
        closeAllPopovers()
        $popover.style.display = 'block'
        updatePopover($button, $popover)
      }
    })

    // Close list when clicking outside
    document.addEventListener('click', (e) => {
      if (isPopoverOpen($popover) && !$popover.contains(e.target)) {
        $popover.style.display = 'none'
      }
    })
    document.querySelectorAll('[data-popover-close]').forEach(($close) => {
      $close.addEventListener('click', () => {
        $popover.style.display = 'none'
      })
    })
  }

  function closeAllPopovers() {
    const $popovers = document.querySelectorAll('[data-popover-content]')
    for (const $popover of $popovers) {
      $popover.style.display = 'none'
    }
  }

  /**
   * @param {HTMLElement} $popover
   */
  function isPopoverOpen($popover) {
    return $popover.style.display !== 'none'
  }

  /**
   * @param {HTMLButtonElement} $button
   * @param {HTMLElement} $popover
   */
  function updatePopover($button, $popover) {
    FloatingUIDOM.computePosition($button, $popover, {
      placement: 'right-start',
      middleware: [],
    }).then(({ x, y }) => {
      if (window.innerWidth >= 1024) {
        Object.assign($popover.style, {
          left: `${x}px`,
          top: `${y}px`,
        })
      } else {
        Object.assign($popover.style, {
          position: 'fixed',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
        })
      }
    })
  }

  /**
   * @param {HTMLInputElement} $checkbox
   */
  function initPriceFilterChange($checkbox) {
    $checkbox.addEventListener('change', (event) => {
      document.querySelectorAll(`[data-filter-price]`).forEach(($c) => {
        if ($c !== $checkbox) $c.checked = false
      })

      const $lte = document.querySelector('[name="filter.v.price.lte"]')
      $lte.value = event.target.checked
        ? $checkbox.getAttribute('data-lte')
        : ''
      const $gte = document.querySelector('[name="filter.v.price.gte"]')
      $gte.value = event.target.checked
        ? $checkbox.getAttribute('data-gte')
        : ''

      // document.getElementById('FacetFiltersForm').submit()
    })
  }

  /**
   * 絞り込みopenボタンクリック時の処理
   * @param {HTMLButtonElement} $button
   */
  function initOnFilterOpenClick($button) {
    $button.addEventListener('click', function () {
      filterContainer.classList.add('opened')
    })
  }

  /**
   * 絞り込みcloseボタンクリック時の処理
   * @param {HTMLButtonElement} $button
   */
  function initOnFilterCloseClick($button) {
    $button.addEventListener('click', function () {
      filterContainer.classList.remove('opened')
    })
  }

  function main() {
    // Init popovers
    document.querySelectorAll('[data-popover-button]').forEach(initPopover)

    // document
    //   .querySelectorAll('[data-filter-price]')
    //   .forEach(initPriceFilterChange)

    openFilterButton.forEach(initOnFilterOpenClick)
    closeFilterButton.forEach(initOnFilterCloseClick)
  }

  main()
}
